/**
 * The `cf-issue-index` idb-keyval store (`url -> AssetOwnerRecord`) that
 * `sw.ts` writes, exposed here so *page-side* code can read it too --
 * Cache Storage and IndexedDB are both origin-scoped, not exclusive to the
 * service worker, so there is no need to round-trip through `postMessage`
 * just to read what the SW already wrote. Kept in one file so the database
 * name/store name literals exist exactly once; `sw.ts` and any page-side
 * reader both import `getIssueIndexStore()` rather than each hard-coding
 * `createStore('cf-issue-index', 'urls')` and risking the two drifting
 * apart.
 *
 * Dependency-free like `eviction-queue.ts` in this same directory -- no
 * `@config`, no Workbox -- so it stays importable from `sw.ts`'s reduced
 * `injectManifest` bundling environment. `idb-keyval` itself is fine here:
 * `sw.ts` already imports it directly at module top level.
 */
import { createStore, entries, type UseStore } from 'idb-keyval';

import type { AssetOwnerRecord } from './eviction-queue';

let store: UseStore | undefined;

export function getIssueIndexStore(): UseStore {
	store ??= createStore('cf-issue-index', 'urls');
	return store;
}

export async function getIssueIndexEntries(): Promise<
	Array<[string, AssetOwnerRecord]>
> {
	return entries<string, AssetOwnerRecord>(getIssueIndexStore());
}
